import React, { useEffect, useState } from "react";
import "./third.style.scss";
import { Modal, Alert, Button, Card, Input } from "antd";
import CompleteCover from "../completeCover/completeCover.index";
import DragDrop from "../../../components/dataEntry/Upload/DragDrop";
import { get, post, responseValidator, SERVER } from "../../../../api";
import { toast } from "react-toastify";
import Loading from "../../../../loading/loading.index";
import { Complete, Error, Pending } from "../verification.index";
import ehraz from '../../../../assets/images/ehraz.jpg'
export default function ThirdLevel(props) {
    const [emailStatus, setEmailStatus] = useState(0);
    const [emailText, setEmailText] = useState(null);
    const [emailCode, setEmailCode] = useState(null);
    const [isCodeSent, setIsCodeSent] = useState(false);
    const [emailTextLoading, setEmailTextLoading] = useState(false);
    const [emailCodeLoading, setEmailCodeLoading] = useState(false);

    const [phoneStatus, setPhoneStatus] = useState(0);
    const [phoneText, setPhoneText] = useState(null);
    const [phoneCode, setPhoneCode] = useState(null);
    const [isPhoneCodeSent, setIsPhoneCodeSent] = useState(false);
    const [phoneTextLoading, setPhoneTextLoading] = useState(false);
    const [phoneCodeLoading, setPhoneCodeLoading] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [uploadLoading, setUploadLoading] = useState(false);
    const [nationalCardSrc, setNationalCardSrc] = useState(null);
    const [contentTypeCard, setContentTypeCard] = useState(null);

    const [selfiPhotoSrc, setSelfiPhotoSrc] = useState(null);
    const [selfiPhotoState, setSelfiPhotoState] = useState();
    const [contentTypeSelfiPhoto, setContentTypeSelfiPhoto] = useState(null);

    const [adminMessage, setAdminMessage] = useState(null);
    const [mediaSurveyState, setMediaSurveyState] = useState(0);

    function finishUploadMeliCardHandler(e) {
        setNationalCardSrc(e.response.data.file);
    }

    function finishUploadSelfiHandler(e) {
        setSelfiPhotoSrc(e.response.data.file);
    }


    function uploadNationalCardInfo() {
        Modal.info({
            title: 'شرایط آپلود تصویر کارت ملی',
            content: (
                <div>
                    <p>محدودیت حداقل حجم فایل تا 20 کیلوبایت و حداکثر تا 5 مگابایت میباشد.</p>
                    <p>تنها فرمت jpg یا png مجاز میباشد.</p>
                </div>
            ),
            onOk() { },
        });
    }
    function uploadSelfiInfo() {
        Modal.info({
            title: 'شرایط آپلود تصویر سلفی',
            content: (
                <div>
                    <img src={ehraz} style={{ padding: "15px", marginBottom: "6px" }} />
                    <p>
                        متن روی برگه :<br />
                        اینجانب.... ضمن مطالعه کامل قوانین و مقررات، مدارک خود را
                        جهت احراز هویت در وب سایت مجموعه تم ایکس ارسال‌می نمایم
                        و متعهد می شوم حساب کاربری خود را در اختیار هیچ شخص دیگری قرار ندهم.
                        <br />
                        نام و نام خانوادگی :
                        <br />
                        تاریخ :
                        <br />
                        امضاء :
                    </p>
                </div>
            ),
            onOk() { },
        });
    }

    function emailClickHandler() {
        setEmailTextLoading(true);
        post(`/User/Email/Confirmation/Send`, {
            email: emailText
        }).then(response => {
            setEmailTextLoading(false);
            if (responseValidator(response.status)) {
                toast.success("ایمیل شما ثبت گردید");
                setEmailStatus(1);
                setIsCodeSent(false);
               /* toast.success(response.data.message);
                setIsCodeSent(true);*/
            } else toast.error(response.data.message);
        });
    }

    function emailCodeHandler() {
        setEmailCodeLoading(true);
        post(`/User/Email/Confirmation/Confirm`, {
            email: emailText,
            code: emailCode
        }).then(response => {
            setEmailCodeLoading(false);
            if (responseValidator(response.status)) {
                toast.success("ایمیل شما تایید گردید");
                setEmailStatus(1);
                setIsCodeSent(false);
            } else {
                toast.error(response.data.message);
                setEmailCode(null);
            }
        });
    }
    function sendSurveyMediaClickHandler() {
        setUploadLoading(true);
        post(`/AuthSurvey/Create`, {}).then(response => {
            setUploadLoading(false);
            if (responseValidator(response.status)) {
                toast.success(response.data.message);
                setIsPhoneCodeSent(true);
            } else toast.error(response.data.message);
        });
    }

    function phoneClickHandler() {
        setPhoneTextLoading(true);
        post(`/User/LandlineNumber/Call`, {
            landlineNumber: phoneText
        }).then(response => {
            setPhoneTextLoading(false);
            if (responseValidator(response.status)) {
                toast.success(response.data.message);
                setIsPhoneCodeSent(true);
            } else toast.error(response.data.message);
        });
    }

    function phoneCodeHandler() {
        setPhoneCodeLoading(true);
        post(`/User/LandlineNumber/Confirm`, {
            code: phoneCode,
            landlineNumber: phoneText
        }).then(response => {
            setPhoneCodeLoading(false);
            if (responseValidator(response.status)) {
                toast.success(response.data.message);
                setPhoneStatus(1);
                setIsPhoneCodeSent(false);
            } else {
                toast.error(response.data.message);
                setPhoneCode(null);
            }
        });
    }

    function getDetail() {
        get("/User/Auth/Level3").then(response => {
            setIsLoading(false);
            if (responseValidator(response.status) && response.data.data) {
                if (response.data.data.emailConfirmed) {
                    setEmailStatus(1);
                }
                if (response.data.data.email) {
                    setEmailText(response.data.data.email.toLowerCase());
                }
                if (response.data.data.landlineNumberConfirmed) {
                    setPhoneStatus(1);
                }
                if (response.data.data.landlineNumber) {
                    setPhoneText(response.data.data.landlineNumber);
                }
                if (
                    response.data.data.melliCard &&
                    response.data.data.melliCard.fileByteContent
                ) {
                    setNationalCardSrc(
                        response.data.data.melliCard.fileByteContent
                    );
                    setContentTypeCard(
                        response.data.data.selfiPhoto.contentType
                    );
                }

                if (
                    response.data.data.selfiPhoto &&
                    response.data.data.selfiPhoto.fileByteContent
                ) {
                    setSelfiPhotoSrc(
                        response.data.data.selfiPhoto.fileByteContent
                    );
                    setContentTypeSelfiPhoto(
                        response.data.data.selfiPhoto.contentType
                    );
                }

                if (response.data.data.mediaSurveyState) {
                    setMediaSurveyState(response.data.data.mediaSurveyState);
                    if (response.data.data.adminMessage) {
                        setAdminMessage(response.data.data.adminMessage);
                    }
                }

            } else {
                toast.error(response.data.message);
            }
        });
    }

    useEffect(() => {
        setEmailText(null);
        setPhoneText(null);
        getDetail();
    }, []);

    function finishSelfiHandler(e) {
        //setSelfieStatus(1);
        setNationalCardSrc(e.response.data.file);
    }

    return (
        <div className="tmex-verification-level3">
            {isLoading && <Loading />}
            <Card style={{ marginTop: "0" }}>
                {props.data.description &&
                    props.data.description
                        .split(".")
                        .map((item, index) =>
                            item === "" || index === 1 ? null : (
                                <h5>{item + "."}</h5>
                            )
                        )}
            </Card>
            <div className="boxes">
                <div className="info">
                    <Card
                        title={
                            emailStatus !== 0 ? (
                                <Complete title="تایید ایمیل" />
                            ) : (
                                "تایید ایمیل"
                            )
                        }
                        className="code-verification-box"
                        cover={
                            emailStatus === 0 ? null : (
                                <div>
                                    <CompleteCover text="تایید شده" />
                                </div>
                            )
                        }
                    >
                        {!isCodeSent ? (
                            <div className="items">
                                <Input
                                    type={"email"}
                                    onPressEnter={emailClickHandler}
                                    value={emailText}
                                    placeholder="ایمیل"
                                    onChange={e => setEmailText(e.target.value)}
                                />
                                <span />
                                <Button
                                    type={"primary"}
                                    onClick={emailClickHandler}
                                    disabled={!emailText}
                                    loading={emailTextLoading}
                                >
                                    ارسال کد
                                </Button>
                            </div>
                        ) : (
                            <>
                                <div className="items">
                                    <Input
                                        type={"number"}
                                        onPressEnter={emailCodeHandler}
                                        value={emailCode}
                                        placeholder="کد"
                                        onChange={e => setEmailCode(e.target.value)}
                                    />

                                    <Button
                                        className="my-btn"
                                        type={"link"}
                                        onClick={() => setIsCodeSent(false)}
                                    >
                                        تغییر ایمیل
                                    </Button>
                                    <span />
                                    <Button
                                        type={"primary"}
                                        onClick={emailCodeHandler}
                                        disabled={!emailCode}
                                        loading={emailCodeLoading}
                                    >
                                        تایید
                                    </Button>
                                </div>
                                <div className="items">
                                    <p style={{ fontSize: "12px" }}>
                                        کد تایید به ایمیل {emailText} ارسال شده است
                                    </p>
                                </div></>
                        )}
                    </Card>

                    <Card
                        title={
                            phoneStatus !== 0 ? (
                                <Complete title="تایید شماره تلفن ثابت" />
                            ) : (
                                "تایید شماره تلفن ثابت"
                            )
                        }
                        className="code-verification-box"
                        cover={
                            phoneStatus === 0 ? null : (
                                <div>
                                    <CompleteCover text="تایید شده" />
                                </div>
                            )
                        }
                    >
                        {!isPhoneCodeSent ? (
                            <div className="items">
                                <Input
                                    type={"number"}
                                    onPressEnter={phoneClickHandler}
                                    maxLength={12}
                                    value={phoneText}
                                    placeholder="شماره تلفن ثابت"
                                    onChange={e => setPhoneText(e.target.value)}
                                />
                                <span />
                                <Button
                                    type={"primary"}
                                    onClick={phoneClickHandler}
                                    disabled={!phoneText}
                                    loading={phoneTextLoading}
                                >
                                    ارسال کد
                                </Button>
                            </div>
                        ) : (
                            <>
                                <div className="items">
                                    <Input
                                        type={"number"}
                                        onPressEnter={phoneCodeHandler}
                                        value={phoneCode}
                                        placeholder="کد"
                                        onChange={e => setPhoneCode(e.target.value)}
                                    />
                                    <Button
                                        className="my-btn"
                                        type={"link"}
                                        onClick={() => setIsPhoneCodeSent(false)}
                                    >
                                        تغییر شماره
                                    </Button>
                                    <span />
                                    <Button
                                        type={"primary"}
                                        onClick={phoneCodeHandler}
                                        disabled={!phoneCode}
                                        loading={phoneCodeLoading}
                                    >
                                        تایید
                                    </Button>
                                </div>
                                <p style={{ fontSize: "12px" }}>
                                    کد تایید طی تماس تلفنی به شماره {phoneText}{" "}
                                    به شما اعلام میگردد
                                </p>
                            </>
                        )}
                    </Card>
                </div>
                <div className="documents">
                    <Card

                        className="national-card-uploader"
                        title={
                            mediaSurveyState &&
                                mediaSurveyState.id === 0 ? (
                                <Pending title="تصویر کدملی و سلفی" />
                            ) : mediaSurveyState.id === 1 ? (
                                <Complete title="تصویر کدملی و سلفی" />
                            ) :
                                mediaSurveyState.id === 2 ?
                                    (<Error title="تصویر کدملی و سلفی" />)
                                    :
                                    "تصویر کدملی و سلفی"
                        }
                        cover={mediaSurveyState &&
                            mediaSurveyState.id === 0 ?
                            (<div>
                                <CompleteCover text="در انتظار بررسی" />
                            </div>) :
                            mediaSurveyState.id === 1 ? (<div>
                                <CompleteCover text="تایید شده" />
                            </div>) :
                                null
                        }
                    >
                        <div className="upload-columns-list">
                            <div className="upload-column">
                                <p>آپلود تصویر کارت ملی</p>

                                {
                                    nationalCardSrc &&
                                    <img style={{ padding: "15px", width: "300px" }} src={`data:${contentTypeCard};base64,${nationalCardSrc}`} />
                                }
                                <DragDrop
                                    accept="image/*"
                                    finish={e => finishUploadMeliCardHandler(e)}
                                    name="melliCardPhoto"
                                    multiple={false}
                                    url={SERVER + "/User/MelliCard"}
                                    pr
                                />
                                <Button onClick={uploadNationalCardInfo}>راهنما آپلود تصویر کارت ملی</Button>
                            </div>
                            <div className="upload-column">
                                <p>آپلود تصویر سلفی</p>
                                {
                                    selfiPhotoSrc &&
                                    <img style={{ padding: "15px", width: "300px" }} src={`data:${contentTypeSelfiPhoto};base64,${selfiPhotoSrc}`} />
                                }
                                <DragDrop
                                    accept="image/*"
                                    finish={e => finishUploadSelfiHandler(e)}
                                    name="selfiPhoto"
                                    multiple={false}
                                    url={SERVER + "/User/SelfiPhoto"}
                                />
                                <Button onClick={uploadSelfiInfo}>راهنما آپلود تصویر سلفی</Button>

                            </div>
                        </div>

                        {adminMessage && (
                            <Alert
                                style={{ marginTop: "22px" }}
                                type="error"
                                message={`پیام مدیر :${adminMessage}`}
                                banner
                            />
                        )}
                        <Button
                            type={"primary"}
                            onClick={sendSurveyMediaClickHandler}
                            disabled={selfiPhotoSrc === '' || nationalCardSrc === '' ||
                                emailStatus !== 1 || phoneStatus !== 1}
                            loading={uploadLoading}
                        >
                            ثبت مدارک
                        </Button>
                    </Card>

                </div>
            </div>
        </div>
    );
}
